<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-title class="text-h5">
        Delete Party Section
      </v-card-title>
      <v-card-text>Permanently delete this section <b>({{ title }})</b>? <br> You can't undo this.</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="onCardDelete"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PEPartyCardDeleteDialog',

  props: {
    onCardDelete: {
      type: Function,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>
